import React, { useCallback, useState } from 'react';

import { Book } from '@/utils/bookRouting';
import { useTheme } from '@/contexts/ThemeContext';

import CategoryBook from './CategoryBook';

interface CollectionRowProps {
  collection: {
    name: string;
    description: string;
    books: Book[];
  };
  onBookClick: (book: Book) => void;
}

const CollectionRow: React.FC<CollectionRowProps> = ({ collection, onBookClick }) => {
  const { theme } = useTheme();
  const isDarkMode = theme === 'dark';
  const [loadedCoverBookIds, setLoadedCoverBookIds] = useState<string[]>([]);

  if (collection.books.length === 0) {
    return null;
  }

  const allCoversReady = loadedCoverBookIds.length >= collection.books.length;

  const handleCoverReady = useCallback((bookId: string) => {
    setLoadedCoverBookIds((currentBookIds) =>
      currentBookIds.includes(bookId)
        ? currentBookIds
        : [...currentBookIds, bookId],
    );
  }, []);

  return (
    <section className="mb-24 w-full max-w-6xl mx-auto">
      <div className="mb-8">
        <h2
          className={`portrait-text-app mb-4 text-2xl font-bold lg:text-3xl ${
            isDarkMode ? 'text-theme-primary-dark' : 'text-theme-primary-light'
          }`}
        >
          {collection.name}
        </h2>
        <p className={`text-sm lg:text-lg ${isDarkMode ? 'text-theme-primary-dark' : 'text-theme-primary-light'}`}>
          {collection.description}
        </p>
      </div>
      <div className="flex flex-wrap gap-8">
        {collection.books.map((book) => (
          <CategoryBook
            key={`${collection.name}-${book.id}`}
            book={book}
            onBookClick={onBookClick}
            showCover={allCoversReady}
            onCoverReady={handleCoverReady}
          />
        ))}
      </div>
    </section>
  );
};

export default CollectionRow;
